import { render, staticRenderFns } from "./SimilarProducts.vue?vue&type=template&id=0295908a&scoped=true"
import script from "./SimilarProducts.vue?vue&type=script&lang=js"
export * from "./SimilarProducts.vue?vue&type=script&lang=js"
import style0 from "./SimilarProducts.vue?vue&type=style&index=0&id=0295908a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0295908a",
  null
  
)

export default component.exports